<template>
  <div class="loader-wrap" @click.stop>
    <img src="/loader.svg"/>
  </div>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String
    }
  }
};
</script>

<style scoped lang='scss'>
.loader-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  overflow: hidden;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100px;
    animation-name: rotate;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(90deg);
    }
    50% {
      transform: rotate(180deg);
    }
    75% {
      transform: rotate(270deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>